import { render, staticRenderFns } from "./LngChooser.vue?vue&type=template&id=138e6735&"
import script from "./LngChooser.vue?vue&type=script&lang=js&"
export * from "./LngChooser.vue?vue&type=script&lang=js&"
import style0 from "./LngChooser.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports